var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',_vm._g(_vm._b({model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'vue-slider',Object.assign({}, _vm.$attrs, _vm.options),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }